import styled from 'styled-components';

const Style = styled.div`
  margin-top: 8px;

  .ant-timeline-item-last {
    padding-bottom: 0px;
  }

  .ant-timeline-item-last > .ant-timeline-item-content {
    min-height: auto;
  }

  .ant-timeline-item-tail {
    left: 1px;
  }

  .ant-timeline-item-content {
    font-size: 14px;
    margin: 0 0 0 14px;
    font-weight: 500;
    color: var(--base-gray-90);
  }

  .unfilled .ant-timeline-item-content {
    color: var(--base-gray-50);
  }

  .ant-timeline {
    padding-left: 6px;
  }

  .ant-timeline-item {
    padding-bottom: 5px;
  }

  .ant-timeline-item-head  {
    background: transparent;
  }

  svg {
    width: 14px;
    height: 14px;
  }

  .dot-empty {
    width: 14px;
    height: 14px;
    margin-right: 5px;
    background: #E1E1E1;
    border-radius: 100%;
  }
`;

export default Style;
